import { fetchWithAuth } from '../apiClient';

export async function submitFeedback({ message, okayToContact }) {
  const res = await fetchWithAuth('/api/feedback', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      message,
      okayToContact: Boolean(okayToContact),
    }),
  });

  return await res.json();
}
